import Vue from 'vue'
import axios from "axios";

export const global = new Vue({
    data: {
        organization_id: null,
        inbox: null,
        approved: null,
        declined: null,
        pages: null,
        contests: null,
        userOrganizations: []
    },
    computed: {
        organization: {
            get: function () { return this.$globals.organization_id },
            set: function (newId) { this.$globals.organization_id = newId; this.$globals.updateRepos(); }
        }
    },
    methods: {
        updateRepos() {
            this.$globals.getDemos();
            this.$globals.getContests();
        },
        getDemos() {
            var self = this;
            console.log("[Globals] Demo's ophalen");
            axios
                .get(
                    "/demo?status=open"
                )
                .then((res) => {
                    self.inbox = null;
                    self.Loading = false;
                    self.inbox = res.data;
                    console.log(self.inbox);
                })
                .catch((error) => {
                    self.Loading = false;
                    console.error(error);
                });
            axios
                .get(
                    "/demo?status=approved"
                )
                .then((res) => {
                    self.approved = null;
                    self.Loading = false;
                    self.approved = res.data;
                    console.log(self.approved);
                })
                .catch((error) => {
                    self.Loading = false;
                    console.error(error);
                });
            axios
                .get(
                    "/demo?status=removed"
                )
                .then((res) => {
                    self.declined = null;
                    self.Loading = false;
                    self.declined = res.data;
                    console.log(self.declined);
                })
                .catch((error) => {
                    self.Loading = false;
                    console.error(error);
                });
        },
        getContests() {
            var self = this;
            console.log("[Globals] contests ophalen");
            axios({
                method: "GET",
                crossdomain: true,
                headers: { "Content-Type": "Content-Type:application/json" },
                url:
                    "/contest"
            })
                .then(function (response) {
                    self.contests = response.data;
                })
                .catch(function (error) {
                    self.errors = error.response.data;
                    self.isLoading = false;
                });
        }
    }
})
